const BING_TAG_ID = process.env.REACT_APP_BING_TAG_ID;

class BingAds {
  constructor() {
    this.initialized = false;
    this.tagId = BING_TAG_ID;
  }

  init() {
    if (this.initialized || !this.tagId) return;

    (function (w, d, t, r, u) {
      var f, n, i;
      (w[u] = w[u] || []),
        (f = function () {
          var o = { ti: BING_TAG_ID };
          (o.q = w[u]), (w[u] = new window.UET(o)), w[u].push("pageLoad");
        }),
        (n = d.createElement(t)),
        (n.src = r),
        (n.async = 1),
        (n.onload = n.onreadystatechange =
          function () {
            var s = this.readyState;
            (s && s !== "loaded" && s !== "complete") ||
              (f(), (n.onload = n.onreadystatechange = null));
          }),
        (i = d.getElementsByTagName(t)[0]),
        i.parentNode.insertBefore(n, i);
    })(window, document, "script", "//bat.bing.com/bat.js", "uetq");

    this.initialized = true;
  }

  track(eventName, parameters = {}) {
    if (!this.initialized || !window.uetq) return;

    window.uetq.push("event", eventName, {
      event_category: parameters.category || "engagement",
      event_label: parameters.label || "",
      event_value: parameters.value || 0,
      ...parameters
    });
  }

  page() {
    if (!this.initialized || !window.uetq) return;
    window.uetq.push("pageLoad");
  }

  identify(userId, traits = {}) {
    if (!this.initialized || !window.uetq) return;

    const userInfo = {};
    if (traits.email) userInfo.em = traits.email;
    if (traits.phone) userInfo.ph = traits.phone;

    if (Object.keys(userInfo).length > 0) {
      window.uetq.push("set", userInfo);
    }
  }

  trackPurchase(revenue, currency = "USD") {
    if (!this.initialized || !window.uetq) return;

    window.uetq.push("event", "", {
      revenue_value: revenue,
      currency: currency
    });
  }
}

export default new BingAds();
